module.exports = { "default": require("core-js/library/fn/symbol/split"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/symbol/split.js
// module id = KCcS
// module chunks = 3